// removed by extract-text-webpack-plugin
module.exports = {"header":"expired-session-modal_header--lyJr7CGS","expiredSessionModal":"expired-session-modal_expiredSessionModal--167fZdSG","body":"expired-session-modal_body--ynxC9mdG"};


//////////////////
// WEBPACK FOOTER
// ./components/doctify-modals/src/styles/expired-session-modal.scss
// module id = 646
// module chunks = 0